import type { WavespeedModelConfig } from '../types';
import { clampTo, hasImageInput } from '../../tools';

export const xaiConfigs: Record<string, WavespeedModelConfig> = {
    'x-ai/grok-imagine-image-v2.0/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/x-ai/grok-imagine-image-v2.0/text-to-image
        apiPath: '/x-ai/grok-imagine-image-v2.0/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, image_resolution, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '1:1', ['1:1', '2:3', '3:2', '16:9', '9:16'] as const, '1:1'),
                resolution: clampTo(image_resolution?.toLowerCase() || '2k', ['1k', '2k'] as const, '2k'),
                quality: clampTo(
                    providerOptions?.quality || 'medium',
                    ['low', 'medium'] as const,
                    'medium',
                ),
            };
        },
    },
    'x-ai/grok-imagine-image-v2.0/edit': {
        // https://wavespeed.ai/zh-CN/models/x-ai/grok-imagine-image-v2.0/edit
        apiPath: '/x-ai/grok-imagine-image-v2.0/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (!hasImage) {
                throw new Error('Missing Image Input');
            }
            return {
                prompt: prompt,
                // 图片 URL
                images: image_urls.slice(0, 1),
                resolution: clampTo(image_resolution?.toLowerCase() || '2k', ['1k', '2k'] as const, '2k'),
                quality: clampTo(
                    providerOptions?.quality || 'medium',
                    ['low', 'medium'] as const,
                    'medium',
                ),
            };
        },
    },
};